import { studentHelps } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IStudentHelpData, IStudentHelps } from "../../models/master/studentHelp";

 export default new (class StudentHelpService {
  public getStudentHelp = async (
    id: number
  ): Promise<IApiResponse<IStudentHelpData>> => {
    try {
      let endPoint = urlBinder(studentHelps.GET_STUDENT_HELP, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentHelpData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentHelpData>;
      } else {
        throw error;
      }
    }
  };

  public getStudentHelps = async (
    configUserRole? : number
  ): Promise<IApiResponse<Array<IStudentHelps>>> => {
    try {
      let endPoint = urlBinder(studentHelps.GET_ALL_STUDENT_HELPS, [configUserRole]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IStudentHelps>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IStudentHelps>>;
      } else {
        throw error;
      }
    }
  };

  public createStudentHelp = async (
    data: any
  ): Promise<IApiResponse<boolean|any>> => {
    try {
      let endPoint = studentHelps.CREATE_STUDENT_HELP;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean|any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean|any>;
      } else {
        throw error;
      }
    }
  };

  public updateStudentHelp = async (
    data: any,id:number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(studentHelps.UPDATE_STUDENT_HELP, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateStudentHelpPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = studentHelps.UPDATE_STUDENT_HELP_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteStudentHelp = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(studentHelps.DELETE_STUDENT_HELP, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
